// import { Academics, College, MajorsNCareers, Social, SupportFinancial } from './';

import { Academics} from './academics';
import { College } from './college';
import { MajorsNCareers } from './major-careers'
import { Social } from './social'
import { SupportFinancial } from './support-financial'

export class CollegeSearchInput {
  college: College = new College();
  majorsCareers: MajorsNCareers = new MajorsNCareers();
  academics: Academics = new Academics();
  social: Social = new Social();
  supportFinancial: SupportFinancial = new SupportFinancial();
  page = 1;
  pageSize = 50;
  sortBy = 'A-Z';
}
